/* eslint-disable import/prefer-default-export */
export const MAIN_ICON_COLORS = {
  INFO: '#8b80db',
  SHADOW: '#717070',
  DANGER: '#f04f52',
  PRIMARY: '#ff5300',
  WHITE: '#FFFFFF',
  SUCCESS: '#6ec85c',
  GRAY_LIGHT: '#191919',
  GRAY_LIGHTER: '#272727',
  INFO_ARROW: '#3c3b3b',
};
